import React from "react";
import PropTypes from "prop-types";
import NextLink from "next/link";

import {
  concatenateQueryParams,
  isLocalURL,
} from "@gonoodle/gn-universe-utils";

const Link = React.forwardRef(function Link(
  {
    children,
    events,
    className,
    href,
    as,
    passHref,
    shallow,
    replace,
    linkParams,
    onClick,
    ...rest
  },
  forwardedRef,
) {
  const parsedHref = isLocalURL(href)
    ? href
    : concatenateQueryParams("/external-link-disclaimer", {
        ...linkParams,
        href,
      });

  return (
    <NextLink
      href={parsedHref}
      as={as}
      passHref={passHref}
      shallow={shallow}
      replace={replace}
      {...rest}
      className={className}
      onClick={onClick}
      ref={forwardedRef}
    >
      {children}
    </NextLink>
  );
});

export default Link;

Link.propTypes = {
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  passHref: PropTypes.bool,
  replace: PropTypes.bool,
  shallow: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      properties: PropTypes.shape({}).isRequired,
    }),
  ),
  linkParams: PropTypes.shape({
    sourceName: PropTypes.string,
    sourcePage: PropTypes.string,
    sourcePageType: PropTypes.string,
    sourceElement: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

Link.defaultProps = {
  as: undefined,
  passHref: false,
  replace: false,
  shallow: false,
  events: [],
  className: undefined,
  linkParams: undefined,
  onClick: () => {},
};
